var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsterisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 373,
    viewBox: "0 0 259 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6081 238.894L0.315615 236.743L3.03701 126.63L89.3319 128.694L48.0688 52.9006L144.808 0.173027L186.145 75.9262L231.175 2.2833L325.192 59.6692L280.235 133.357L366.528 135.508L363.806 245.622L277.512 243.557L318.775 319.35L222.036 372.078L180.699 296.325L135.668 369.968L41.6514 312.582L86.6081 238.894Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.521663e9f27acdb05c9fdfadb7c20d9c.svg";
export { ForwardRef as ReactComponent };